import { createContext, useState } from 'react';

import OmeMeetEntryInfoData from './OmeMeetEntryInfoData';

export const OmeMeetEntryInfoStateContext = createContext();

const OmeMeetEntryInfoContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetEntryInfoData.INITIAL_STATE);

  return (
    <OmeMeetEntryInfoStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetEntryInfoStateContext.Provider>
  );
};

export default OmeMeetEntryInfoContextProvider;